import { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import StatusSelect from '../../../components/StatusSelect';
import { useGetStatuses } from '../../../hooks/useIncidentApi';

interface StatusFieldProps {
  defaultValue?: string;
}

export const StatusField = ({ defaultValue }: StatusFieldProps): ReactElement => {
  const { data: response } = useGetStatuses();
  const { control } = useFormContext();
  const { field } = useController({
    name: 'status',
    control,
    defaultValue,
  });

  // TODO 23553 - Server-side fix response.data.data
  return <StatusSelect options={response?.data || []} value={field.value} onChange={field.onChange} />;
};
